import React from "react";
import { withNamespaces } from 'react-i18next';

const AcAlojamento = ({t}) => {
  return (
    <>
      <div className="accordion" id="accordionExample_alojamento">
        {/* 1 */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="alojamento_heading1">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#alojamento_collapse1"
              aria-expanded="true"
              aria-controls="alojamento_collapse1"
            >
              {t('moduleFaqs:S5.A.A1.T') }
            </button>
          </h2>
          <div
            id="alojamento_collapse1"
            className="accordion-collapse collapse"
            aria-labelledby="alojamento_heading1"
            data-bs-parent="#accordionExample_alojamento"
          >
            <div className="accordion-body">
              <p className="p_accordion">
                <span dangerouslySetInnerHTML={{ __html: t('moduleFaqs:S5.A.A1.P1')}}></span>
                <a className='link' target='_blank' rel='noreferrer' href={t('moduleFaqs:S5.A.A1.Link.Link')} title={t('moduleFaqs:S5.A.A1.Link.Title')}>{t('moduleFaqs:S5.A.A1.Link.NameLink')}</a>
                <span  dangerouslySetInnerHTML={{ __html: t('moduleFaqs:S5.A.A1.P2') }}></span>
              </p>
            </div>
          </div>
        </div>
        {/* 2 */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="alojamento_heading2">
            <button
              className="accordion-button collapsed text-left"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#alojamento_collapse2"
              aria-expanded="false"
              aria-controls="alojamento_collapse2"
            >
              {t('moduleFaqs:S5.A.A2.T') }
            </button>
          </h2>
          <div
            id="alojamento_collapse2"
            className="accordion-collapse collapse"
            aria-labelledby="alojamento_heading2"
            data-bs-parent="#accordionExample_alojamento"
          >
            <div className="accordion-body">
              <p className="p_accordion" dangerouslySetInnerHTML={{ __html: t('moduleFaqs:S5.A.A2.P1') }}></p>
            </div>
          </div>
        </div>
        {/* 3*/}
        <div className="accordion-item">
          <h2 className="accordion-header" id="alojamento_heading3">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#alojamento_collapse3"
              aria-expanded="false"
              aria-controls="alojamento_collapse3"
            >
              {t('moduleFaqs:S5.A.A3.T') }
            </button>
          </h2>
          <div
            id="alojamento_collapse3"
            className="accordion-collapse collapse"
            aria-labelledby="alojamento_heading3"
            data-bs-parent="#accordionExample_alojamento"
          >
            <div className="accordion-body">
              <p className="p_accordion">{t('moduleFaqs:S5.A.A3.P1') }
              </p>
              <p className="p_accordion" dangerouslySetInnerHTML={{ __html: t('moduleFaqs:S5.A.A3.P2') }}></p>
              <ul>
                <li>
                  <p className="p_next" dangerouslySetInnerHTML={{ __html: t('moduleFaqs:S5.A.A3.UL.LI1') }}></p>
                </li>
                <li>
                  <p className="p_next" dangerouslySetInnerHTML={{ __html: t('moduleFaqs:S5.A.A3.UL.LI2') }}></p>
                </li>
                <li>
                  <p className="p_next" dangerouslySetInnerHTML={{ __html: t('moduleFaqs:S5.A.A3.UL.LI3') }}></p>
                </li>
                <li>
                  <p className="p_next"dangerouslySetInnerHTML={{ __html: t('moduleFaqs:S5.A.A3.UL.LI4') }}></p>
                </li>
                <li>
                  <p className="p_next" dangerouslySetInnerHTML={{ __html: t('moduleFaqs:S5.A.A3.UL.LI5') }}>
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        {/* 4*/}
        <div className="accordion-item">
          <h2 className="accordion-header" id="alojamento_heading4">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#alojamento_collapse4"
              aria-expanded="false"
              aria-controls="alojamento_collapse4"
            >
              {t('moduleFaqs:S5.A.A4.T') }
            </button>
          </h2>
          <div
            id="alojamento_collapse4"
            className="accordion-collapse collapse"
            aria-labelledby="alojamento_heading4"
            data-bs-parent="#accordionExample_alojamento"
          >
            <div className="accordion-body">
              <p className="p_accordion" dangerouslySetInnerHTML={{ __html: t('moduleFaqs:S5.A.A4.P1') }}>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default withNamespaces() (AcAlojamento);
